import type { ListBuilderList } from '../../../types';
import { createStandardClientColumns } from '../columns';
import {
	CLIENT_MOBILE_CARD_CONFIG,
	DEFAULT_LIST_REQUIRED_FIELDS,
	createClientKanbanConfig,
} from '../shared';

/**
 * All Clients list configuration
 * Complete list of all clients with contact information and key metrics
 */
export const defaultClientsAllList: ListBuilderList = {
	id: 'default-clients-all',
	cacheTTL: 600000,
	name: 'All Clients',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	filterRules: {
		salespeople: {
			defaultValue: [],
			additionalValues: [
				{
					values: [{ id: 'ME', label: 'Me' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'ME_ALTERNATE', label: 'Me (Alternate)' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{ type: 'rule', action: 'clients:view:self', negated: false },
						],
					},
				},
				{
					values: [{ id: 'null', label: 'Unassigned' }],
					applyIf: {
						type: 'group',
						joiner: 'AND',
						negated: false,
						children: [
							{
								type: 'rule',
								action: 'clients:view:unassigned',
								negated: false,
							},
						],
					},
				},
			],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
			boundedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
		clientDeletedRecords: {
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'clients:detail:any', negated: true },
				],
			},
		},
	},
	columns: createStandardClientColumns(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description:
		'Complete list of all clients with contact information and key metrics',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	gridConfig: {
		enabled: false,
		layout: {
			type: 'responsive',
			columns: {
				xs: 1,
				sm: 2,
				md: 3,
				lg: 4,
				xl: 5,
			},
			gap: 'md',
		},
		sections: [
			{
				id: 'main',
				name: 'Main Content',
				order: 1,
				visible: true,
				fields: [],
			},
		],
		cardStyle: {
			variant: 'outlined',
			padding: 'md',
			hover: true,
			shadow: false,
			borderRadius: 'lg',
		},
		clickable: false,
		selectable: false,
		virtualized: false,
		lazyLoadImages: true,
	},
	sortOrder: 0,
	viewMode: 'table',
	kanbanConfig: createClientKanbanConfig(),
};
